import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';

// Internal
import Dashboard from './components/Dashboard';
import CodatCallback from './components/CodatCallback';
import Login from './pages/login';
import { auth, logout } from './services/firebase';

// Antd
import { message, Spin } from 'antd';

// Fonts
import WebFont from 'webfontloader';

// Firebase
import { useAuthState } from 'react-firebase-hooks/auth';

import { IOrganization, OrgContext } from './hooks/useOrg';

// Styles
import styles from './App.module.scss';
import Invite from './pages/invite';
import SwitchOrganization from './pages/organization/switch';

function App() {
  // Load fonts
  React.useEffect(() => {
    WebFont.load({
      google: {
        families: ['Inter:300,400,500,600'],
      },
    });
  }, []);

  return <AppRouter />;
}

function AppRouter() {
  const navigate = useNavigate();
  const [user, loading, error] = useAuthState(auth);
  const [org, setOrg] = useState({} as IOrganization);

  if (user) {
    console.log('(user as any).accessToken', (user as any).accessToken);
  }

  React.useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate('/');
      return;
    }

    fetch(process.env.REACT_APP_API_URL + '/organizations/current', {
      method: 'get',
      headers: new Headers({
        Authorization: 'Basic ' + (user as any).accessToken,
      }),
    })
      .then((response) => response.json())
      .then(({ data }) => {
        if (!data.id) {
          logout();

          message.error('Sorry, you seem to be not part of the closed beta.');
        } else {
          setOrg(data);
        }
      })
      .catch((e) => {
        console.log(e);

        logout();

        message.error('Something went wrong');
      });
  }, [user, loading]);

  if (loading) {
    return <Spin size="large" className={styles.loading} />;
  } else if (user) {
    return (
      <OrgContext.Provider value={org}>
        <Routes>
          <Route path="/invite" element={<Invite />} />
          <Route path="/switch" element={<SwitchOrganization />} />
          <Route path="/codat-callback" element={<CodatCallback />} />
          <Route path="*" element={<Dashboard />} />
        </Routes>
      </OrgContext.Provider>
    );
  } else {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }
}

export default App;
